import { render, staticRenderFns } from "./UserSelectDialog.vue?vue&type=template&id=689ae2bd"
import script from "./UserSelectDialog.vue?vue&type=script&lang=js"
export * from "./UserSelectDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports